import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const getCategoryItemsWithoutProfileId = async (os: string, tenantName: string, selectedResourceType: string, name: string) => {
    if (os.toUpperCase() === "MAC" || os.toUpperCase() === "MACOS")
        os = "macos"
    let url = `${NGROK}/api/computers/operation-system/get-all-apps?categoryName=${name}&os=${os.toUpperCase()}&tenantName=${tenantName}`;

    if (selectedResourceType === "folder")
        url = `${NGROK}/api/computers/operation-system/get-all-folders?categoryName=${name}&os=${os.toUpperCase()}&tenantName=${tenantName}`;
    else if (selectedResourceType === "url")
        url = `${NGROK}/api/computers/operation-system/get-all-url-control?categoryName=${name}&os=${os.toUpperCase()}&tenantName=${tenantName}`;

    try {
        const data = await apiClient({
            method: "GET",
            url
        });

        return data;
    } catch (error) {
        console.error("Error deleting custom policy :", error);
        throw error;
    }

}


export const getAllCategoryItemsWithoutProfileId = async (os: string, tenantName: string, selectedResourceType: string) => {
    if (os.toUpperCase() === "MAC" || os.toUpperCase() === "MACOS")
        os = "macos"
    let url = `${NGROK}/api/computers/operation-system/get-all-apps?os=${os.toUpperCase()}&tenantName=${tenantName}`;

    if (selectedResourceType === "folder")
        url = `${NGROK}/api/computers/operation-system/get-all-folders?os=${os.toUpperCase()}&tenantName=${tenantName}`;
    else if (selectedResourceType === "url")
        url = `${NGROK}/api/computers/operation-system/get-all-url-control?os=${os.toUpperCase()}&tenantName=${tenantName}`;

    try {
        const data = await apiClient({
            method: "GET",
            url
        });

        return data;
    } catch (error) {
        console.error("Error deleting custom policy :", error);
        throw error;
    }

}


export const postCategory = async (payload: any) => {
    let url = `${NGROK}/api/category`;

    try {
        const data = await apiClient({
            method: "POST",
            url,
            data: payload
        });

        return data;
    } catch (error) {
        console.error("Error deleting custom policy :", error);
        throw error;
    }

}

export const updateCategory = async (payload: any) => {
    let url = `${NGROK}/api/category`;

    try {
        const data = await apiClient({
            method: "PUT",
            url,
            data: payload
        });

        return data;
    } catch (error) {
        console.error("Error deleting custom policy :", error);
        throw error;
    }
}


export const removeCategory = async (type: string, category: string, activeTab: string, tenantName: string) => {
    if (activeTab.toUpperCase() === "MAC" || activeTab.toUpperCase() === "MACOS")
        activeTab = "MACOS";

    let url = `${NGROK}/api/category/${category}/${type.toUpperCase()}/${activeTab.toUpperCase()}/${tenantName}`;

    try {
        const data = await apiClient({
            method: "DELETE",
            url
        });

        return data;
    } catch (error) {
        console.error("Error deleting custom policy :", error);
        throw error;
    }

}


export const getResourcesByPattern = async (os: string, tenantName: string, selectedResourceType: string, pattern: string) => {
    if (os.toUpperCase() === "MAC" || os.toUpperCase() === "MACOS")
        os = "macos"

    let url = `${NGROK}/api/computers/operation-system/get-resources-by-pattern?os=${os.toUpperCase()}&tenantName=${tenantName}&pattern=${encodeURIComponent(pattern)}`;

    if (selectedResourceType === "folder")
        url = `${NGROK}/api/computers/operation-system/get-resources-by-pattern?os=${os.toUpperCase()}&tenantName=${tenantName}&resourceType=folder&pattern=${encodeURIComponent(pattern)}`;
    else if (selectedResourceType === "url")
        url = `${NGROK}/api/computers/operation-system/get-resources-by-pattern?os=${os.toUpperCase()}&tenantName=${tenantName}&resourceType=url&pattern=${encodeURIComponent(pattern)}`;
    else
        url = `${NGROK}/api/computers/operation-system/get-resources-by-pattern?os=${os.toUpperCase()}&tenantName=${tenantName}&resourceType=app&pattern=${encodeURIComponent(pattern)}`;

    try {
        const data = await apiClient({
            method: "GET",
            url
        });

        return data;
    } catch (error) {
        console.error("Error fetching resources by pattern:", error);
        throw error;
    }
}